import moment from "moment";
import { isValidPhoneNumber } from "libphonenumber-js";

export const validateRequired = value => {
  if (value === null || value === undefined) return false;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return true;
  if (typeof value === "string") return value.trim().length;
  if (Array.isArray(value)) return value.length;
  return true;
};

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateDate = date => {
  return moment(date, "YYYY-MM-DD", true).isValid();
};

export const validateDateTime = date => {
  return moment(date, "YYYY-MM-DD HH:mm:ss", true).isValid();
};

export const validatePhoneNumber = phone => {
  return isValidPhoneNumber(phone);
};

export const validateSSN = ssn => {
  const justNumbers = ssn.replace(/[^0-9]+/g, "");
  return justNumbers.length == 9;
};

export const validateZipcode = zipcode => {
  return zipcode.match(/^\d{5}(?:-\d{4})?$/);
};

export const validateNumberGreaterEqualThan = (value, min) => {
  return value >= min;
};

export const validateNumberLessEqualThan = (value, max) => {
  return value <= max;
};

export const validateLengthGreaterEqualThan = (value, min) => {
  return value.trim().length >= min;
};

export const validateLengthLessEqualThan = (value, max) => {
  return value.trim().length <= max;
};

export const validateLengthEqualThan = (value, length) => {
  return value.trim().length == length;
};

export const validateIsNumber = number => {
  const validAreaCode = number.match(/^[0-9]*$/);
  return validAreaCode;
};

export const validateNumberPositive = value => {
  if (value > 0) return true;
  return false;
};

export const validateNumberNotNegative = value => {
  if (value >= 0) return true;
  return false;
};

export const validateNumberNotFloat = number => {
  if (number.toString().match(/^\d*\.\d+$/) == null) return true;
  return false;
};
